import angular from 'angular';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  loyaltyStatistics: state.user.loyaltyStatistics,
});

angular
  .module('myConsultApp')
  .controller('mergeUserController', ($ngRedux, $rootScope, $scope, $http, ENV, $interval, $timeout) => {
    $scope.initData = () => {
      $scope.errors = [];
      $scope.processing_merge_user = false;
      $scope.merge_to_id = null;
      $rootScope.mergeSubmissionCompleted = true;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.initData();
    };

    $scope.searchClients = (query) => {
      return $scope
        .getUsers($http, ENV, {
          application_subscription: 5,
          is_active: true,
          is_anonymized: false,
          autoComplete: true,
          groups: 2,
          order: '-last_name',
          search: query,
        })
        .then((res) => res);
    };

    $scope.searchClientsPage = (query) => {
      return $scope.getUsersByUrl($http, query).then((res) => res);
    };

    $scope.selectUser = (data) => {
      $scope.merge_to_id = data.id;
    };

    $scope.submitMergeUser = (merge_to_id) => {
      if (!$scope.merge_to_id){
        $scope.merge_to_id = merge_to_id;
      }
      $scope.processing_merge_user = true;
      $rootScope.mergeSubmissionCompleted = false;
      const payload = {
        merge: {
          merge_to_id: $scope.merge_to_id
        },
      };
      $scope
        .mergeUserProfile($http, ENV, $rootScope.userId, payload)
        .then((res) => {
          $scope.$apply(() => {
            $scope.initData();
            $rootScope.refreshLoyaltyStatistics();
            $rootScope.getData();
            $scope.getUser($http, ENV, $rootScope.userId);
            //$rootScope.closeComponent({ shouldHardClose: !$rootScope.isUserRoute });
            $rootScope.onDisplayMergeDetail({
              userId: $rootScope.userId,
              mergeId: res.id,
            });
          });
        })
        .catch((error) => {
          $scope.processing_merge_user = false;
          $rootScope.mergeSubmissionCompleted = true;
          if (error.data['merge']) {
            $scope.$apply(() => {
              $scope.errors = error.data['merge'].error;
              console.log($scope.errors);
            });
            return;
          }
          const errors = error.data['merge'];
          let result = [];
          if (errors) {
            result = Object.keys(errors)
              .map((key) => {
                const keyString = key
                  .split('_')
                  .map((item) => $scope.capitalize(item))
                  .join(' ');
                const value = errors[key];
                if (Array.isArray(value)) {
                  return value.map((x) => `${keyString}: ${x}`);
                }
                return `${keyString}: ${errors[key]}`;
              })
              .flat(1);
          } else {
            result.push('Something went wrong. Please try again.');
          }

          $scope.$apply(() => {
            $scope.errors = result;
            console.log($scope.errors);
          });
        });
    };

    $scope.close = () => {
      $rootScope.closeComponent();
      $rootScope.getData();
      $rootScope.refreshUser();
    };

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $scope.processing_merge_user = false;
    });
  })
  .directive('mergeUser', () => {
    return {
      templateUrl: 'templates/v2/merge-user.html',
    };
  });
